export const TOKEN_ENDPOINT = '/api/auth/o/token/';
export let OAUTH_CLIENT_ID = '';
export let OAUTH_CLIENT_SECRET = '';
export const ACCESS_TOKEN_REFRESH_BUFFER_MS = 15_000;

interface OAuthClientConfig {
  OAUTH_CLIENT_ID: string;
  OAUTH_CLIENT_SECRET: string;
}

export async function initializeOAuthClientConfig(
  fetchConfig: typeof fetch = fetch,
): Promise<void> {
  const response = await fetchConfig(new URL('auth-config.json', document.baseURI), {
    cache: 'no-store',
  });
  if (!response.ok) {
    throw new Error(`OAuth client configuration request failed (${response.status}).`);
  }

  const config = (await response.json()) as Partial<OAuthClientConfig>;
  if (
    typeof config.OAUTH_CLIENT_ID !== 'string' ||
    !config.OAUTH_CLIENT_ID.trim() ||
    typeof config.OAUTH_CLIENT_SECRET !== 'string' ||
    !config.OAUTH_CLIENT_SECRET.trim()
  ) {
    throw new Error('OAuth client configuration is incomplete.');
  }

  OAUTH_CLIENT_ID = config.OAUTH_CLIENT_ID;
  OAUTH_CLIENT_SECRET = config.OAUTH_CLIENT_SECRET;
}
